import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SimilarEntityAlert = ({ similarMatch, entityName, onKeepExisting, onUseNew }) => {
  const { t } = useTranslation();

  if (
    !similarMatch ||
    similarMatch.loading ||
    similarMatch.action ||
    similarMatch.matchedByExactName ||
    similarMatch.matchedByMapping ||
    !similarMatch.matchedBySimilarName
  ) {
    return null;
  }

  const displayName = similarMatch.similarEntity?.divName || similarMatch.entityName || '';
  const message = `${t('Similar entity found')}: ${displayName}`;

  return (
    <div className="mb-2 d-flex justify-content-between align-items-center">
      <div>
        <strong>{message}</strong>
      </div>
      <div>
        <Button variant="outline-secondary" size="sm" className="mr-2" onClick={() => onKeepExisting(entityName)}>
          {t('Use Existing')}
        </Button>
        <Button variant="outline-secondary" size="sm" onClick={() => onUseNew(entityName)}>
          {t('Use New')}
        </Button>
      </div>
    </div>
  );
};

export default SimilarEntityAlert;
